"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.95 52.45",
    width: "59.95",
    height: "52.45"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.22,0A26.23,26.23,0,0,1,52.11,22.25l3.27-4.9a2.49,2.49,0,1,1,4.15,2.77L51.71,31.74a2.5,2.5,0,0,1-3.53,0L39.34,21.62a2.49,2.49,0,0,1,3.76-3.28L47.18,23a21.22,21.22,0,1,0-21,24.46,2.5,2.5,0,0,1,0,5A26.23,26.23,0,0,1,26.22,0Z",
    style: {
      fill: '#95989a'
    }
  }));
};

exports["default"] = _default;